import {
	AppPage,
	MimaDateFilter,
	MimaFilter,
	MimaText,
	PageLoader,
	MimaButton,
	MimaDropdownFilter,
	TagBanner,
} from '../../components';
import styles from '../../assets/styles/AppHome/AppHome.module.scss';
import BusinessInsightCard from './BusinessInsightCard';
import ProgressBar from '@ramonak/react-progress-bar';
import { IoIosCheckmarkCircle, IoMdCloseCircle } from 'react-icons/io';
import BusinessChartCard from './BusinessChartCard';
import QuickLinksCard from './QuickLinksCard';
import { MdCancel } from 'react-icons/md';
import { businessStore, transactionStore, userStore } from '../../stores';
import React, { useState } from 'react';
import { Formik } from 'formik';
import { toJS } from 'mobx';
import { AnimatePresence } from 'framer-motion';
import { AddBusinessContainer, BusinessReportDLContainer, NumberVerificationContainer, SecurityContainer, WithdrawalAccountContainer } from '../../containers';
import constant from '../../utils/constant';
import Survey from '../../components/Survey/Survey';

const AppHome = ({
	tradingName,
	transactionsSummary,
	expensePercentage,
	expenseAnalysis,
	loading,
	onSubmit,
	validationSchema,
	filterPeriod,
	resetFilter,
	toDoListTotal,
	isActivated,
	hasPin,
	refresh,
	isOnboarded,
	hasWithdrawal,
	goToOnboarding,
	goToSettings,
	showBusinesses,
	addBusinessModal,
	allBusinesses,
	closeModal,
	setAddBusiness,
	reportModal,
	viewReport,
	hasAddedCard,
	goToSetPin,
	goToWithdrawalAccount,
	goToCardInfo,
	pinModal,
	withdrawalAccountModal,
	cardInfoModal,
	goToNumVerification,
	numVerificationModal,
	hasVerifiedNumber,
	filterPeriods,
	getDate,
}) => {
	const [onReset, setOnReset] = useState(false);
	const [showSurvey, setShowSurvey] = useState(false);
	const permissions = new Set(
		toJS(userStore.user?.permissions?.map(perm => perm.name))
	);
	const [curr, setCurr2] = useState(businessStore.defaultCurrency ? businessStore.defaultCurrency : transactionsSummary[0]?.currencyCode)
	// const [showTagBanner, setShowTagBanner] = useState(transactionStore.transactions.filter(x => {
	// 	return (x.tagged === "NO-TAG" & x.category !== "OFFLINE")
	// }) ? true : false)
	const [showTagBanner, setShowTagBanner] = useState(() => {
		const filteredTransactions = transactionStore.transactions.filter(
			x => x.inflowType === constant.FLOW_TYPE.Untagged
		);
		return filteredTransactions.length > 0;
	});

	const [ninVerification, setNinVerification] = useState(true);

	const businesses = businessStore.businesses;

	return (
		<AppPage tradingName={tradingName} refresh={refresh}>
			{loading ? (
				<PageLoader title="Refreshing record..." loading={loading} />
			) : (
				<>
					<MimaText variant="subtitle" mb={2} align="center">
						You are viewing Insights for {filterPeriod}.
					</MimaText>

					<div className={styles.homeTop}>
						<div className={styles.multi}>
							<div onClick={showBusinesses} className={allBusinesses ? styles.multi_select : ""}>
								<div>
									{businesses.length === 1 ? "Add Another Business" : allBusinesses ? "Select Business" : "Switch Businesses"}
								</div>

								{allBusinesses && <IoMdCloseCircle className={styles.multi_select_close} />}

							</div>


							{(allBusinesses && businesses.length > 1) ? (
								<>
									{
										businesses.map((biz) => (
											<div
												key={biz._id}
												className={biz._id === businessStore.bId ? styles.multi_biz_list_active : styles.multi_biz_list}
												onClick={() => {
													businessStore.setBId(biz._id);
													businessStore.setBusiness(
														businessStore.businesses.filter(
															bizz => bizz._id === biz._id
														)[0]
													);
													refresh();
													showBusinesses();
												}}>
												{biz.tradingName}
											</div>
										))
									}

									<div className={styles.multi_biz_list_btns}>
										<MimaButton
											title="Add New Business"
											buttonColor="var(--color-primary)"
											variant="filter"
											onClick={() => setAddBusiness(true)}
											width={24}
											mb={2}
										/>
										<MimaButton
											title="Refresh"
											variant="filter"
											onClick={() => refresh()}
											width={24}
											mb={2}
										/>

									</div>



								</>

							) : ""}


						</div>
						<Formik
							initialValues={{
								startDate: '',
								endDate: '',
								period: '',
								periodText: '',
							}}
							validationSchema={validationSchema}
							onSubmit={onSubmit}>
							{({
								handleChange,
								handleBlur,
								handleSubmit,
								setFieldValue,
								values,
								errors,
								touched,
							}) => (
								<MimaFilter
									filterClick={() => {
										setOnReset(false);
										handleSubmit();
									}}
									loading={loading}
									resetClick={() => {
										setOnReset(true);
										resetFilter();
									}}>
									<div style={{ display: 'flex', flexDirection: 'column' }}>
										<MimaDropdownFilter
											labelTitle="Filter period"
											placeholder="Select Period"
											variant="medium"
											name="period"
											data={filterPeriods}
											onChange={data => {
												const dates = getDate(data.key)
												setFieldValue("period", data.key)
												setFieldValue("startDate", dates.startDate)
												setFieldValue("endDate", dates.endDate)
												setFieldValue("periodText", data.value)
											}}
											error={errors.period}
											touched={touched.period}
										/>

										{values.period === "custom" && (
											<div style={{ display: 'flex', gap: "2rem" }}>
												<MimaDateFilter
													labelTitle="start date"
													name="startDate"
													value={!onReset ? values.startDate : ''}
													onChange={text => {
														setOnReset(false);
														setFieldValue('startDate', text);
													}}
													onBlur={handleBlur}
													width={18}
													touched={touched.startDate}
													error={errors.startDate}
												/>
												<MimaDateFilter
													labelTitle="End date"
													name="endDate"
													value={!onReset ? values.endDate : ''}
													onChange={text => {
														setOnReset(false);
														setFieldValue('endDate', text);
													}}
													onBlur={handleBlur}
													width={18}
													touched={touched.endDate}
													error={errors.endDate}
												/>
											</div>
										)}
									</div>
								</MimaFilter>
							)}
						</Formik>
					</div>


					<div className={styles.main}>
						{permissions.has('CAN CREATE ANOTHER BUSINESS') && (
							<BusinessInsightCard transactionsSummary={transactionsSummary} setCurr2={setCurr2} filterPeriod={filterPeriod} />
						)}
						<QuickLinksCard viewReport={viewReport} />
						{permissions.has("CAN CREATE BUSINESS WITHDRAWAL ACCOUNT") && toDoListTotal < 100 ? (
							<div className={styles.toDo}>
								<MimaText variant="smallBold" mb={1}>
									You are almost done!
								</MimaText>
								<div className={styles.toDo__group}>
									<div className={styles.toDo__items}>
										<p>Activate Account</p>
										<span className={isActivated ? styles.toDo__green : ''}>
											{isActivated ? <IoIosCheckmarkCircle /> : <MdCancel />}
										</span>
									</div>
									{/* <div
								className={
									isOnboarded ? styles.toDo__items : styles.toDo__items_hover
								}
								onClick={goToOnboarding}>
								<p> Verification </p>
								<span className={isOnboarded ? styles.toDo__green : ''}>
									{isOnboarded ? <IoIosCheckmarkCircle /> : <MdCancel />}
								</span>
							</div> */}
									<div
										className={
											hasPin ? styles.toDo__items : styles.toDo__items_hover
										}
										onClick={!hasPin ? goToSetPin : () => { }}>
										<p> Set Transaction Pin</p>
										<span className={hasPin ? styles.toDo__green : ''}>
											{hasPin ? <IoIosCheckmarkCircle /> : <MdCancel />}
										</span>
									</div>
									<div
										className={
											hasWithdrawal ? styles.toDo__items : styles.toDo__items_hover
										}
										onClick={!hasWithdrawal && goToWithdrawalAccount}>
										<p>Set Withdrawal Account</p>
										<span className={hasWithdrawal ? styles.toDo__green : ''}>
											{hasWithdrawal ? <IoIosCheckmarkCircle /> : <MdCancel />}
										</span>
									</div>
									<div
										className={
											hasVerifiedNumber ? styles.toDo__items : styles.toDo__items_hover
										}
										onClick={!hasVerifiedNumber ? goToNumVerification : () => { }}>
										<p>Verify Phone Number</p>
										<span className={hasVerifiedNumber ? styles.toDo__green : ''}>
											{hasVerifiedNumber ? <IoIosCheckmarkCircle /> : <MdCancel />}
										</span>
									</div>
									{/* <div
										className={
											hasAddedCard ? styles.toDo__items : styles.toDo__items_hover
										}
										onClick={!hasAddedCard && goToCardInfo}>
										<p>Add Card Info</p>
										<span className={hasAddedCard ? styles.toDo__green : ''}>
											{hasAddedCard ? <IoIosCheckmarkCircle /> : <MdCancel />}
										</span>
									</div> */}
								</div>
								<ProgressBar
									completed={toDoListTotal}
									bgColor="var(--color-success)"
									animateOnRender
								/>
							</div>
						) : (
							''
						)}
						<div>


							{permissions.has('CAN VIEW BUSINESS TRANSACTIONS SUMMARY') &&
								(
									<>
										<div className={styles.expense}>
											<span>Expense Analysis</span>
										</div>

										{expenseAnalysis.filter((x) => {
											return x.currencyCode === curr
										}).map((analysis, i) => (
											<BusinessChartCard
												expenseAnalysis={analysis.value}
												expensePercentage={expensePercentage}
												currencyCode={analysis.currencyCode}
												key={i}
											/>
										))}

									</>
								)}
						</div>

						{showTagBanner && (
							<div className={styles.tagBanner}>
								<TagBanner
									setShowTagBanner={setShowTagBanner}
									showTagBanner={showTagBanner}
								/>
							</div>
						)}
					</div>

					{
						(addBusinessModal || reportModal || pinModal || withdrawalAccountModal || numVerificationModal || showSurvey) && (
							<div className="modal">
								<AnimatePresence>
									{addBusinessModal && (
										<AddBusinessContainer closeModal={closeModal} setShowSurvey={setShowSurvey} showSurvey={showSurvey} />
									)}

									{reportModal && (
										<BusinessReportDLContainer closeModal={closeModal} setShowSurvey={setShowSurvey} />
									)}
									{pinModal && (
										<SecurityContainer closeModal={closeModal} />
									)}
									{withdrawalAccountModal && (
										<WithdrawalAccountContainer closeModal={closeModal} />
									)}
									{numVerificationModal && (
										<NumberVerificationContainer closeModal={closeModal} />
									)}
									{showSurvey && (
										<Survey
											title=""
											reviewId={userStore.reviewId}
											closeModal={() => {
												setShowSurvey(false);
											}}
										/>
									)}
								</AnimatePresence>
							</div>
						)
					}
				</>)}
		</AppPage>
	);
};

export default AppHome;
